import { MutationTree } from 'vuex';
import { StatisticState } from './types';

export const mutations: MutationTree<StatisticState> = {

  setPushStatisticDetail: (state, data) => {
    state.pushStatisticDetail = data
  },
  pushPushStatisticDetail: (state, data) => {
    state.pushStatisticDetail = state.pushStatisticDetail?.concat(data)
  },
  setPushStatisticDetailFlag: (state, flag: string) => {
      state.pushStatisticDetailFlag = flag;
  },

  setPushStatisticGroup: (state, data) => {
    state.pushStatisticGroup = data;
  },
  setMessagesCount: (state, data) => {
    state.pushMessageCount = data;
  },

  setPushSubscribers: (state, data) => {
    state.pushSubscribers = data;
  },
  setPushHistories: (state, data) => {
    state.pushHistories = data;
  },

};